import { Empty, errorView, Loading } from '../states/States';
import { text } from '../app/i18n';
import { useLoad } from '../views/useLoad';
import { useAppServices } from '../views/ViewContext';

/**
 * File d'attention (ADR-082 §9) : une projection — Work Items, Findings ouverts, écarts
 * bloquants — triée par le serveur de façon déterministe (sévérité, blocage, échéance,
 * ancienneté). Aucune seconde file : tout ce qui s'actionne ouvre une tâche.
 */
interface AttentionEntry {
  kind: 'work_item' | 'finding' | 'readiness_gap';
  id: string;
  title: unknown;
  severity: string;
  blocking: boolean;
  subject?: { type: string; id: string };
  work_item_id?: string;
  due_at?: string;
}

const KIND_LABEL: Readonly<Record<AttentionEntry['kind'], string>> = { work_item: 'Tâche', finding: 'Constat', readiness_gap: 'Écart de readiness' };

export function AttentionPage({ onOpenTask }: { onOpenTask: (workItemId: string) => void }) {
  const services = useAppServices();
  const [loaded, reload] = useLoad<AttentionEntry[]>('attention', async () => (await services.client.query<AttentionEntry[]>('ListAttention', {})).data);
  return (
    <section className="ay-view" aria-labelledby="ay-attention-title">
      <header className="ay-view__header">
        <h1 id="ay-attention-title">À traiter</h1>
        <button type="button" className="ay-button ay-button--secondary" onClick={reload}>
          Actualiser
        </button>
      </header>
      {loaded.status === 'loading' && <Loading />}
      {loaded.status === 'error' && errorView(loaded.error)}
      {loaded.status === 'ready' && loaded.value.length === 0 && <Empty label="Rien à traiter." />}
      {loaded.status === 'ready' && loaded.value.length > 0 && (
        <div className="ay-table-wrap">
          <table className="ay-table">
            <thead>
              <tr>
                <th scope="col">Nature</th>
                <th scope="col">Intitulé</th>
                <th scope="col">Sévérité</th>
                <th scope="col">Objet</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {loaded.value.map((entry) => (
                <tr key={`${entry.kind}:${entry.id}`}>
                  <td>{KIND_LABEL[entry.kind]}</td>
                  <td>{typeof entry.title === 'string' ? entry.title : text(entry.title as Record<string, string>, 'fr', entry.id)}</td>
                  <td>
                    <span className={`ay-badge${entry.blocking ? ' ay-badge--danger' : ''}`}>{entry.severity}</span>
                  </td>
                  <td>{entry.subject === undefined ? '—' : entry.subject.type}</td>
                  <td>
                    {entry.work_item_id === undefined ? (
                      '—'
                    ) : (
                      <button type="button" className="ay-button ay-button--secondary" onClick={() => onOpenTask(entry.work_item_id!)}>
                        Ouvrir la tâche
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
